<template>
  <div class="page-visit">
    <crm-panel :title="'客户公海'">
      <div class="page-buttons">
        <crm-button
          v-if="auth.allocationCustomer && auth.allocationCustomer.toggleStatus"
          :buttonType="'secondary'"
          :text="'分配'"
          @click="handleAllocation()"
        >
        </crm-button>
        <crm-button
          v-if="
            auth.highseaApplyCustomer && auth.highseaApplyCustomer.toggleStatus
          "
          :text="'申请'"
          :disabled="isDownload"
          @click="handleApply()"
        >
        </crm-button>
        <crm-button
          v-if="auth.highseaRuleQuery && auth.highseaRuleQuery.toggleStatus"
          :buttonType="'plain'"
          :text="'公海规则'"
          :disabled="isDownload"
          @click="handleRole()"
        >
        </crm-button>
      </div>
      <!-- 搜索条 -->
      <div class="mt20">
        <el-form ref="searchForm" :model="searchForm" :inline="true">
          <el-form-item label="">
            <div class="select-data-picker">
              <el-select
                v-model="searchForm.searchDateType"
                style="width:145px;"
              >
                <el-option
                  :key="item.name"
                  v-for="item in optionList"
                  :label="item.name"
                  :value="item.value"
                >
                </el-option>
              </el-select>
              <el-date-picker
                value-format="yyyy-MM-dd"
                :editable="false"
                v-model="time"
                type="daterange"
                range-separator="至"
                start-placeholder="开始日期始"
                end-placeholder="结束日期止"
                :picker-options="pickerOptions"
              >
              </el-date-picker>
            </div>
          </el-form-item>
          <el-form-item label="">
            <el-select
              clearable
              v-model="searchForm.categoryId"
              placeholder="客户类型"
            >
              <el-option
                v-for="item in customType"
                :label="item.name"
                :value="item.id"
                :key="item.id"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="">
            <el-select
              clearable
              v-model="searchForm.customerLevel"
              placeholder="客户等级"
            >
              <el-option
                v-for="item in customLevelList"
                :label="item.name"
                :value="item.uid"
                :key="item.uid"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="">
            <el-select
              clearable
              v-model="searchForm.contractStatus"
              placeholder="签约状态"
            >
              <el-option
                v-for="item in contractStatusList"
                :label="item.name"
                :value="item.value"
                :key="item.name"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="" prop="locataion">
            <el-cascader
              clearable
              placeholder="地区"
              v-model="level3Linkage.selected"
              :props="level3Linkage.props"
              :options="level3Linkage.options"
              @change="searchDistrict(level3Linkage.selected)"
            >
            </el-cascader>
          </el-form-item>
          <el-form-item label="">
            <el-input
              placeholder="根据客户名称查询"
              v-model="searchForm.name"
              class="input-with-select"
            >
              <i
                slot="suffix"
                class="el-input__icon el-icon-search"
                @click="handleSearch"
                style="cursor: pointer"
              ></i>
            </el-input>
          </el-form-item>
        </el-form>
      </div>
      <!-- 拜访记录列表 -->
      <el-table
        :data="results"
        border
        v-loading="loading"
        height="100%"
        style="width: 100%"
        @selection-change="handleSelectionChange"
      >
        >
        <el-table-column type="selection" width="40"> </el-table-column>
        <el-table-column
          prop="name"
          align="center"
          show-overflow-tooltip
          label="客户名称"
        >
        </el-table-column>
        <el-table-column
          width="100"
          prop="categoryName"
          align="center"
          label="客户类型"
        >
        </el-table-column>
        <el-table-column
          width="70"
          prop="customerLevelName"
          align="center"
          label="客户等级"
        >
        </el-table-column>
        <el-table-column
          prop="province"
          align="center"
          show-overflow-tooltip
          label="地区"
          width="140"
        >
          <template slot-scope="scope">
            {{
              scope.row.province +
                '/' +
                scope.row.city +
                '/' +
                scope.row.district
            }}
          </template>
        </el-table-column>
        <el-table-column
          show-overflow-tooltip
          width="70"
          prop="contractStatus"
          align="center"
          label="签约状态"
        >
          <template slot-scope="scope">
            {{ scope.row.contractStatus === '2' ? '未签约' : '已签约' }}
          </template>
        </el-table-column>
        <el-table-column
          prop="gmtCreatedStr"
          width="145"
          align="center"
          label="创建时间"
        >
        </el-table-column>
        <el-table-column
          prop="visitDateStr"
          width="145"
          align="center"
          label="最后拜访时间"
        >
        </el-table-column>
        <el-table-column
          prop="insertCreatedStr"
          width="145"
          align="center"
          label="划入公海时间"
        >
        </el-table-column>
        <el-table-column
          prop="createName"
          width="70"
          align="center"
          label="创建人"
        >
        </el-table-column>
      </el-table>
      <!-- 拜访记录列表分页 -->
      <div class="pageination">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page.sync="searchForm.pageNumber"
          :page-sizes="[10, 20, 50]"
          :page-size="searchForm.pageSize"
          layout="total, sizes, prev, pager, next"
          :total="searchForm.totalCount"
        >
        </el-pagination>
      </div>
    </crm-panel>

    <!-- 分配 -->
    <dialog-distribution
      v-if="results.length > 0"
      ref="dialogDistribution"
      :multiple="true"
      @success="handleSearch"
    ></dialog-distribution>

    <!-- 规则 -->
    <Role
      v-if="roleVisible"
      :visible.sync="roleVisible"
      :detail="detail"
      @close="roleVisible = false"
      @success="handleSearch()"
    >
    </Role>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import config from '~config';
import { newDownloadByUrl } from '@/scripts/utils';
import WeYesOrNoOptions from '~component/base/yes-or-no-options';
import WeSearchSelectTypeOptions from '~component/business/visit/visit-select-type-options';
import crmPanel from '@/components/base/crmPanel';
import crmButton from '@/components/base/crmButton';
import api from '@/services/api/customRecycle/index.js';
import DialogDistribution from './dialogDistribution';

import Role from './role';
import _ from 'lodash';
import city from '@/scripts/city-diction';

export default {
  components: {
    WeYesOrNoOptions,
    WeSearchSelectTypeOptions,
    DialogDistribution,
    crmPanel,
    crmButton,
    Role,
  },
  data() {
    this.optionList = [
      {
        name: '创建时间',
        value: 'create',
      },
      {
        name: '最后拜访时间',
        value: 'visit',
      },
      {
        name: '划入公海时间',
        value: 'insert',
      },
    ];
    this.contractStatusList = [
      {
        name: '已签约',
        value: 1,
      },
      {
        name: '未签约',
        value: 2,
      },
    ];
    return {
      isDownload: false,
      loading: false,
      searchForm: {
        name: '',
        categoryId: '',
        customerLevel: '',
        contractStatus: null,
        searchDateType: 'create',
        startDate: '',
        endDate: '',
        isFinished: null,
        pageNumber: 1,
        pageSize: 10,
        province: '',
        city: '',
        district: '',
      },
      time: [],
      results: [],
      level3Linkage: {
        options: city,
        props: {
          label: 'label',
          value: 'label',
          expandTrigger: 'click',
          checkStrictly: true,
        },
        selected: [],
      },
      pickerOptions: {
        disabledDate: this.dealDisableDate, // 设置禁用状态，参数为当前日期，要求返回 Boolean
        onPick: this.dealOnPick, // 选中日期后会执行的回调
      },
      detail: {},
      // 表格多选
      multipleSelection: [],
      roleVisible: false,
      distributionVisible: false,
    };
  },
  computed: {
    ...mapGetters({
      auth: 'authority/auth',
      userInfo: 'authority/userInfo',
      customType: 'common/customType',
      customLevelList: 'common/customLevelList',
    }),
  },
  watch: {
    'searchForm.searchDateType': {
      handler() {
        this.handleSearch();
      },
    },
    time: {
      handler() {
        this.searchForm.startDate = this.time && this.time.length > 0 ? this.time[0] : '';
        this.searchForm.endDate = this.time && this.time.length > 1 ? this.time[1] : '';
        this.handleSearch();
      },
      deep: true,
    },
    'searchForm.categoryId': {
      handler(val, oldVal) {
        if (val === null || val === oldVal) return;
        this.handleSearch();
      },
      immediate: false,
    },
    'searchForm.customerLevel': {
      handler(val, oldVal) {
        if (val === null || val === oldVal) return;
        this.handleSearch();
      },
      immediate: false,
    },
    'searchForm.contractStatus': {
      handler() {
        this.handleSearch();
      },
    },
    'searchForm.name': {
      handler(val, oldVal) {
        if (val === null || val === oldVal) return;
        this.debounceSearch(val, oldVal);
      },
      immediate: false,
    },
  },
  mounted() {
    // 客户等级
    this.getCustomerLevel();
    // 客户类型下拉菜单
    this.getCustomType({
      pageNumber: 1,
      pageSize: 50,
      code: 'category_customer',
    });
    this.handleSearch();
  },
  methods: {
    ...mapActions({
      getCustomType: 'common/getCustomType',
      getCustomerLevel: 'common/getCustomerLevel',
    }),
    // eslint-disable-next-line
    debounceSearch: _.debounce(function(val, oldVal) {
      if (val === null || val === oldVal) return;
      this.handleSearch();
    }, 400),
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    // 以区域筛选客户
    searchDistrict(val) {
      const [provinceName, cityName, districtName] = val;
      this.searchForm.province = provinceName;
      if (
        cityName !== undefined
        && cityName !== ''
        && cityName !== null
        && cityName.length > 0
      ) {
        this.searchForm.city = cityName.substring(0, cityName.length - 1);
      } else {
        this.searchForm.city = cityName;
      }
      this.searchForm.district = districtName;
      this.handleSearch();
    },
    handleSearch() {
      this.searchForm.pageNumber = 1;
      this.getListData();
    },
    getListData() {
      this.loading = true;
      api
        .queryList(this.searchForm)
        .then((res) => {
          this.searchForm.totalCount = res.data.totalCount;
          this.results = res.data.results || [];
        })
        .finally(() => {
          this.loading = false;
        });
    },
    // 分页 每页显示条数
    handleSizeChange(val) {
      this.searchForm.pageSize = val;
      this.searchForm.pageNumber = 1;

      this.getListData();
    },
    // 分页，当前页改变
    handleCurrentChange(val) {
      this.searchForm.pageNumber = val;
      this.getListData();
    },
    dealDisableDate(time) {
      const limitTime = 60 * 60 * 24 * 1000 * 365;
      const timeTmp = new Date().getTime();
      console.log(timeTmp, 'timeTmp');
      return (
        time.getTime() > Date.now() || time.getTime() < timeTmp - limitTime
      ); // 限制条件，不超过当前日期，不小于当前日期减限制日期，不超过当前日期大于限制日期
    },
    handleAllocation() {
      if (this.multipleSelection.length === 0) {
        this.$message({
          message: '请先选择想要分配的客户！',
          type: 'error',
        });
        return;
      }
      const arr = [];
      this.multipleSelection.forEach(item => arr.push(item.id));
      this.$refs.dialogDistribution.dialogVisible = true;
      this.$refs.dialogDistribution.form.ids = arr;
    },
    handleApply() {
      if (this.multipleSelection.length === 0) {
        this.$message({
          message: '请先选择想要申请的客户！',
          type: 'error',
        });
        return;
      }
      const arr = [];
      this.multipleSelection.forEach(item => arr.push(item.id));
      api
        .applyCustomer({
          ids: arr,
        })
        .then((res) => {
          // const statusTip = {
          //   0: '全部申请成功，请联系主管审核!',
          //   1: '部分申请成功，请联系主管审核!',
          //   2: '申请失败!',
          // };
          this.$message({
            message: res.data.data,
            // message: statusTip[res.data.data],
            // type: res.data.data === 2 ? 'error' : 'success',
          });
          this.handleSearch();
        });
    },
    handleRole() {
      this.roleVisible = true;
    },
  },
};
</script>

<style lang="less">
@import '~@/styles/var.less';
.page-visit {
  display: flex;
  flex: 1;
  width: 100%;
  overflow: hidden;
  .label-cus {
    background-color: rgba(50, 128, 252, 1);
    padding: 0 5px;
    color: #fff;
    border-radius: 4px;
  }
  .label-busi {
    background-color: rgba(3, 184, 207, 1);
    padding: 0 5px;
    color: #fff;
    border-radius: 4px;
  }
  .label-clue {
    background-color: rgba(134, 102, 184, 1);
    padding: 0 5px;
    color: #fff;
    border-radius: 4px;
  }
}
.el-tooltip__popper {
  width: 300px;
}
</style>
